<template>
  <div class="student-tag-topBar">
    <div class="tag-list-topbar">
      <div class="select">
        <!-- 搜索框 -->
        <div class="notice-search">
          <search :placeholder="placeholder" @search="search" />
        </div>
      </div>
      <!-- 添加删除修改 -->
      <div class="notice-operation-part-container">
        <button class="button cancel" @click="cancel" v-show="cancelBtnShow">
          取消
        </button>
        <button class="button add" @click="add" v-show="!cancelBtnShow" v-hasPermi="'sc:labelcondition:edit'">
          添加
        </button>
        <button class="button delete" @click="del" v-show="!cancelBtnShow" v-hasPermi="'sc:labelcondition:delete'">
          删除
        </button>
        <!-- <button class="button delete" @click="delBatch" v-show="!cancelBtnShow">
          批量删除
        </button> -->
        <button
          class="button delete"
          v-show="batchBtnShow"
          @click="handleCheckAllChange"
        >
          {{ checkAllText }}
        </button>
        <button
          class="button delete"
          v-show="batchBtnShow"
          @click="delbatchClick"
        >
          删除
        </button>
        <!-- <button class="button revise" @click="revise" v-show="!cancelBtnShow">
          修改
        </button> -->
      </div>
    </div>
  </div>
</template>

<script>
import search from "@/components/search/search.vue";
export default {
  data() {
    return {
      closableType: false,
      cancelBtnShow: false,
      batchBtnShow: false,
      checkAll: false,
      checkAllText: "全选",
      placeholder: "请输入标签名称",
    };
  },
  components: {
    search,
  },
  props: {
    // 批量删除按钮组显示
    batchBtnShowType: {
      type: [Number, Boolean],
    },
    // 取消按钮显示
    cancelBtnShowType: {
      type: [Number, Boolean],
    },
  },
  watch: {
    // 监听批量删除和取消按钮显示(分页被点击时切换显示状态)
    batchBtnShowType: {
      handler(val) {
        this.batchBtnShow = false;
      },
      immeidate: true,
    },
    cancelBtnShowType: {
      handler(val) {
        this.cancelBtnShow = false;
      },
      immeidate: true,
    },
  },
  methods: {
    // 搜索
    search(e) {
      // console.log(e);
      this.$emit("search", e);
    },
    // 批量删除
    delbatchClick() {
      this.$emit("delbatch", true);
    },
    // 全选
    handleCheckAllChange() {
      this.checkAll = !this.checkAll;
      this.checkAllText = this.checkAll ? "取消全选" : "全选";
      this.$emit("checkAllType", this.checkAll);
    },
    delBatch() {
      this.batchBtnShow = true;
      this.cancelBtnShow = true;
      this.$emit("editShow", "deleteBatch");
    },
    del() {
      this.cancelBtnShow = true;
      this.$emit("editShow", "delete");
    },
    add() {
      this.$emit("addShow", true);
    },
    revise() {
      this.cancelBtnShow = true;
      this.$emit("editShow", "update");
    },
    cancel() {
      this.batchBtnShow = false;
      this.cancelBtnShow = false;
      this.$emit("editShow", "123");
      this.checkAll = false;
      this.checkAllText = "全选";
      this.$emit("checkAllType", this.checkAll);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./studentTagTopBar.scss";
</style>
